// extracted by mini-css-extract-plugin
module.exports = {"tagGroup":"tips_tagGroup__yQbuR","tips1":"tips_tips1__QQdN7","tips2":"tips_tips2__62ei1","placeHolder":"tips_placeHolder__9bKJx"};